import FontAwesome from "react-fontawesome";
import React from "react";
export const ADDPORT = /*#__PURE__*/React.createElement(FontAwesome, {
  name: "fas fa-plus"
});
export const ADDPORTSELECTED = /*#__PURE__*/React.createElement(FontAwesome, {
  name: "fas fa-times"
});
export const INPORT = "IN";
export const OUTPORT = "OUT";
export const CONSTPORT = "*";
export const UNBINARY = "unbinary";
export const CONSTANT = "constant";
export const MAINPORT = "MAINPORT";
export const ADDPRED = "P";
export const ADDFUNC = "F";
export const BOTH = "B";
export const FROM = "F";
export const TO = "T";
export const PREDICATE = "P";
export const FUNCTION = "F";
export const BASIC_CURVYNESS = 85;
export const UNBINARYNODE = "N";
export const CONSTANTNODE = "C";
export const TERNARYNODE = "T";
export const QUATERNARYNODE = "Q";
export const TERNARY = "T";
export const QUATERNARY = "Q";